import { useContext } from "react";
import { useSearchParams } from "react-router-dom";

import { Tabs } from "@mantine/core";
import CommingSoon from "./common/CommingSoon";
import FundCatalougeViewer from "./catalouge/FundCatalougeViewer";
import OpenEndedSummary from "../components/open_ended_summary";
import { MyUserDataContext } from "../contexts";
import { CustomClaims } from "../types";
import ClosedEndedFundProgress from "./dashboard/closed_ended_fund_progress";
import OpenEndedFundProgress from "./dashboard/open_ended_fund_progress";
import PortfolioRequestsProgress from "./dashboard/portfolio_requests_progress";
import ServiceRequestMetabaseDashboard from "./dashboard/ServiceRequestMetabaseDashboard";

//create CustomerInfo component
export default function Home(props: any) {

  const appContext = useContext(MyUserDataContext);
  const [searchParams, setSearchParams] = useSearchParams();

  let userClaims = appContext.firebaseTokenResult?.claims.customClaims as CustomClaims;

  // Mirrors the Firestore rule on {path=**}/services: the page reads every portfolio request.
  const canViewPortfolioRequests = userClaims.admin || userClaims.cr;

  const availableTabs = new Set(["dashboard", "fundraising", "catalouge"]);
  if (userClaims.admin) {
    availableTabs.add("service-requests");
    availableTabs.add("open-ended-fundraising");
  }
  if (canViewPortfolioRequests) availableTabs.add("portfolio-requests");

  const requestedTab = searchParams.get("tab");
  const activeTab = requestedTab && availableTabs.has(requestedTab) ? requestedTab : "dashboard";

  const handleTabChange = (value: string | null) => {
    if (!value || !availableTabs.has(value)) return;
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.set("tab", value);
      return next;
    });
  };

  // console.log("tabValue", activeTab);
  return (
    <>
      {/* <Tabs defaultValue="kyc" value={tabValue} onChange={(value: any) => navigate(`/customers/${id}/${value}`)}> */}
      <Tabs
        style={{ height: "80vh", }}
        onChange={handleTabChange}
        value={activeTab}
        styles={{
          panel: {
            height: "100%",
            justifyContent: "center",
            padding: 20,
            display: "flex",
            overflow: "scroll"


          }
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="dashboard">Dashboard</Tabs.Tab>
          {userClaims["admin"] && <Tabs.Tab value="service-requests">Service Requests</Tabs.Tab>}
          <Tabs.Tab value="fundraising">Fundraising performance</Tabs.Tab>
          {userClaims["admin"] && <Tabs.Tab value="open-ended-fundraising">Open-ended fundraising</Tabs.Tab>}
          {canViewPortfolioRequests && <Tabs.Tab value="portfolio-requests">Portfolio requests performance</Tabs.Tab>}
          <Tabs.Tab value="catalouge">Fund Catalogue</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="dashboard">
          {userClaims["kfh_rm"] && <CommingSoon />}
          {!userClaims["kfh_rm"] && <OpenEndedSummary />}
          {/* <Dashboard fundsData={fundsData} /> */}
        </Tabs.Panel>
        {userClaims["admin"] && (
          <Tabs.Panel value="service-requests">
            {activeTab === "service-requests" && <ServiceRequestMetabaseDashboard />}
          </Tabs.Panel>
        )}
        <Tabs.Panel value="fundraising"
        >

          {(userClaims["admin"] || userClaims["cr"] || userClaims["kfh_oper"]) && activeTab === "fundraising" && <ClosedEndedFundProgress />}
        </Tabs.Panel>
        <Tabs.Panel value="open-ended-fundraising">
          {(userClaims["admin"]) && activeTab === "open-ended-fundraising" && <OpenEndedFundProgress />}
        </Tabs.Panel>
        <Tabs.Panel value="portfolio-requests">
          {canViewPortfolioRequests && activeTab === "portfolio-requests" && <PortfolioRequestsProgress />}
        </Tabs.Panel>
        <Tabs.Panel


          value="catalouge" >

          {/*
              check if production, if so, hide the fund catalouge viewer
              else, show the fund catalouge viewer
            */}

          <div style={{
            // background: "red",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",

            alignContent: "center",
            width: "80%"
          }}>

            <FundCatalougeViewer />
          </div>

        </Tabs.Panel>

      </Tabs>
    </>
  );
}
